import { ApplicationConfig } from "@angular/core";
import { provideRouter, RouteReuseStrategy } from "@angular/router";

import { routes } from "./app.routes";
import { CachedRouteReuseStrategy } from "./cached-route-reuse.strategy";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor, LogLevel, provideAuth, withAppInitializerAuthCheck } from "angular-auth-oidc-client";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: CachedRouteReuseStrategy },
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor()])),
    provideAuth(
      {
        config: {
          authority: environment.issuerUri,
          redirectUrl: environment.redirectUri,
          clientId: environment.clientId,
          scope: environment.scope,
          responseType: "code",
          logLevel: LogLevel.Debug,
          customParamsAuthRequest: { identity_provider: environment.identityProvider },
          secureRoutes: [`${environment.apiBaseUrl}/dashboard`]
        }
      },
      withAppInitializerAuthCheck()
    )
  ]
};

// Cognito ID Response URL
// https://$POOL_DOMAIN.auth.$REGION.amazoncognito.com/oauth2/idpresponse
// https://dev-pfs-entra-id.auth.eu-central-1.amazoncognito.com/oauth2/idpresponse
// https://dev-pfs-entra-id.auth.eu-central-1.amazoncognito.com/oauth2/idpresponse
